module.exports = __webpack_public_path__ + "static/media/return-response.3a939135.png";